;(
	function ( $ ) {
		const popupEl = document.querySelector( '#exit-intent-popup' );
		let timeoutTimer;

		if ( !popupEl ) {
			return;
		}

		function openPopup() {
			$.magnificPopup.open( {
				items: {
					src: $( popupEl ),
					type: 'inline'
				}
			} );

			cancelExitIntent();
		}

		function cancelExitIntent() {
			document.body.removeEventListener( 'mouseleave', openPopup );
			window.clearTimeout( timeoutTimer );
		}

		document.body.addEventListener( 'mouseleave', openPopup );

		$( window ).on( 'load', () => timeoutTimer = window.setTimeout( cancelExitIntent, 60000 ) );

	}( jQuery )
);
